// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatModel_wrapper__1JZCU","modal":"ChatModel_modal__2YoSt","microMessenger":"ChatModel_microMessenger__grQPO"};